import session from "../../../services/session";
import swal from "sweetalert2";
import AdminApi from "../../../services/api";
import CONFIG_COMPANY from "../../../services/myConfig";
import Loc from "../../../services/localization";

const AdminApiService = new AdminApi()
const LocService = new Loc()
export default {
    data() {
        return {
            locale: LocService,
            id: 0,
            model: {
                date: '',
                maxTrainings: 0,
                startAt: '',
                trainingType: "",
                trainerOnSlot: null
            },
            partners: [],
            showAddTrainerToSlot: false,
            trainingNumbers: LocService.t('label_max_people_on_training'),
            types: []
        }
    },
    methods: {
        load: load,
        editTraining: editTraining,
        loadPartners: loadPartners,
        getTrainingTypes: getTrainingTypes
    },
    beforeMount() {
        if (session.getRole() !== 'ROLE_ADMIN' && session.getRole() !== 'ROLE_SUPER_ADMIN') {
            this.$router.push(CONFIG_COMPANY.HOME);
            return;
        }
        this.showAddTrainerToSlot = CONFIG_COMPANY.SHOW_ADD_TRAINER_ON_SLOT;
        this.id = this.$route.query.id
        this.load()
        this.getTrainingTypes()
        if(this.showAddTrainerToSlot){
            this.loadPartners();
        }
    }
}

function loadPartners() {
    let _self = this;
    AdminApiService.getCompanyPayments()
        .then((response) => {
            _self.partners = response.data
        })
        .catch(error => {
            swal( LocService.t('label_error'), error.data.localized_error_message, 'error')
        })
}

function load() {
    AdminApiService.getSlotById(this.id)
        .then((response) => {
            this.model = response.data
            this.model.type = response.data.trainingType
        })
        .catch(error => {
            swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
        })
}

function editTraining() {
    AdminApiService.updateSlot(this.model, this.id)
        .then((response) => {
            swal(LocService.t("label_success"), LocService.t("label_term_success_updated"), 'success')
            this.$router.back()
        })
        .catch(error => {
            swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
        })
}

function getTrainingTypes() {
    let _self = this;
    AdminApiService.getTrainingTypes()
        .then((response) => {
            _self.types = response.data
            // for(var temp in response.data) {
            //     _self.model.type = temp
            //     return
            // }
        })
        .catch(error => {
            swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
        })
}


// WEBPACK FOOTER //
// ./src/components/Trainings/Edit/EditTraining.js